import { ImageLogo } from '~/assets/images';

import { BackgroundContainer, Container, Title } from './styled';

const NotFound = () => {
  return (
    <>
      <BackgroundContainer>
        <Container>
          <ImageLogo />
          <Title>Erro 404, página não encontrada!</Title>
        </Container>
      </BackgroundContainer>
    </>
  );
};

export default NotFound;
